import { ModuleDto, UserDto } from "vamos/cockpit/model/api/vamos.private.api.types";


export default class User {
    Firstname: string;
    Lastname: string;
    Username: string;
    Language: string;
    LanguageDescription: string;
    Email: string;
    ViewConfig: string | object;
    IsEditor: boolean;
    IsClientAdministrator: boolean;
    IsAdministrator: boolean;
    IsInstaller: boolean;
    IsEmailCCEnabled: boolean;
    IsCiamUser: boolean;
    public modules: Record<string, boolean>;
    moduleList: ModuleDto[];

    constructor(userData: UserDto) {
        this.IsEditor = userData.editor;
        this.IsAdministrator = userData.administrator;
        this.IsClientAdministrator = userData.clientAdministrator;
        this.IsInstaller = userData.installer;
        this.IsEmailCCEnabled = userData.isEmailCCEnabled;
        this.Firstname = userData.firstName;
        this.Lastname = userData.lastName;
        this.Username = userData.userName;
        this.IsCiamUser = userData.isCiamUser;
        this.setLanguage(userData.language);
        this.Email = userData.email;
        this.ViewConfig = userData.viewConfig;
        if (this.ViewConfig && (typeof this.ViewConfig == "string")) {
            this.ViewConfig = JSON.parse(this.ViewConfig);
        }
        this.moduleList = userData.modules;
        this.modules = {};
        userData.modules.forEach((module: ModuleDto) => {
            this.modules[module.moduleType] = module.enabled;
        })

    }

    public IsOnlyInstaller(): boolean {
        return this.IsInstaller && !this.IsAdministrator && !this.IsClientAdministrator && !this.IsEditor;
    }

    public hasModule(moduleType: string): boolean {
        const module = this.moduleList.find((module: ModuleDto) => module.moduleType.toString() == moduleType);
        return module?.enabled || false;
    }

    public setLanguage(language: string): void {
        this.Language = language || "de";
        switch (this.Language) {
            case "en":
                this.LanguageDescription = "English";
                break;
            case "cs":
                this.LanguageDescription = "Czech";
                break;
            case "nl":
                this.LanguageDescription = "Dutch";
                break;
            default:
                this.LanguageDescription = "Deutsch";
        }
    }
}